/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through E2E */ /**
 * The entrypoint is responsible to catch all available FOMO coupon shortcodes, fetch
 * from Real Commerce and show two text parts (the offer itself, and a disclaimer).
 */ import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ready } from "@devowl-wp/react-utils";
import { Provider } from "./components/provider.js";
import { FomoCouponBanner } from "./shortcode/fomoCoupon/banner.js";
ready().then(()=>{
    // Iterate over the DOM nodes and render a React component into each node
    const elements = document.querySelectorAll("div.real-commerce-fomo-coupon");
    elements.forEach((item)=>createRoot(item).render(/*#__PURE__*/ _jsx(Provider, {
            configProvider: {
                locale: {
                    locale: ""
                }
            },
            children: /*#__PURE__*/ _jsx(FomoCouponBanner, {
                ...$(item).data()
            })
        })));
});
